import { Select } from "PFComponents/select/select";
import { FrequencyData } from "PFCore/helpers/use_notifications_settings";
import React, { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormNotificationSettings } from "../../edit_account.types";

type NotificationSettingSelectProps = {
  name: keyof FormNotificationSettings;
  options: FrequencyData[];
};

export const NotificationSettingSelect = ({ name, options }: NotificationSettingSelectProps): JSX.Element => {
  const { t } = useTranslation("saasAdmin");
  const { control } = useFormContext();
  const dropdownOptions = useMemo(
    () =>
      options.map((option) => ({
        id: option.value,
        displayElement: option.label,
        item: option.value
      })),
    [options]
  );
  return (
    <Controller
      control={control}
      name={`notificationSettings.${name}`}
      render={({ field: { onChange, value } }) => (
        <Select
          // @ts-ignore
          label={t(`accounts.account.notificationSettings.${name}`)}
          tip={t(`accounts.account.notificationSettings.hints.${name}`)}
          value={dropdownOptions.find(({ id }) => id === value)?.displayElement}
          controlledValue
          options={dropdownOptions}
          handleChange={(value) => {
            onChange(value);
          }}
          selectedIndex={dropdownOptions.findIndex((option) => option.id === value)}
        />
      )}
    />
  );
};
